<template>
    <div>
        <ol class="breadcrumb">
            <li v-for="(item, index) in finishRoute" v-bind:key="index" class="breadcrumb-item">
                <router-link :to="{ name: item.link }">{{item.name}}</router-link>
            </li>
        </ol>
    </div>
</template>

<script>
import Vue from 'vue';


export default {
    name: 'ftsbreadcrumbs',
    props: {
        route: Array
    },
    data() {
        return {
            finishRoute: [],
            routeTemp: [],
            breadcrumbs: []
        }
    },
    watch: {
        '$route' () {
            this.finishRoute = []
            this.getRoute(this.route)
        }
    },
    methods: {
        getRoute(route) {
            this.routeTemp = route

            this.routeTemp.map(item => {
                if (item.meta.breadcrumb) {

                    var itemToFor = item.meta.breadcrumb;

                    for (var i = 0; i < itemToFor.length; i++) {
                        var path = {
                            name: itemToFor[i].name,
                            link: itemToFor[i].link
                        }
                        this.finishRoute.push(path)
                    }
                }

                var nameRoute
                if (item.meta.label) {
                    nameRoute = item.meta.label
                } else {
                    nameRoute = item.name
                }

                var linkRoute = item.components.default.name

                var path = {
                    name: nameRoute,
                    link: linkRoute
                }
                if (path.name != 'Home') {
                    this.finishRoute.push(path)
                }
            })
        }
    },
    mounted() {
        this.getRoute(this.route)
    }
}
</script>

<style lang="scss">
.breadcrumb {
    margin-bottom: 20px;
    .breadcrumb-item {
        padding: 0 12px 0 0;
        &::before {
            content: '\f105';
            font-family: FontAwesome;
            padding: 0 12px 0 0;
        }
        &:first-child {
            &::before {
                content: none
            }
        }
        &:last-child {
            a {
                color: #000;
                pointer-events: none;
            }
        }
    }
}

    .dark-theme {

        .breadcrumb {
            .breadcrumb-item {
                a {
                    color: #00B1FF;
                }
                &:last-child {
                    a {
                        color: #fff;
                        pointer-events: none;
                    }
                }
            }
        }
    }
</style>
